const hiddenMenuConsole = process.env.REACT_APP_CONSOLE_HIDDEN_MENU || JSON.stringify([]);


const config = {
  environment: process.env.REACT_APP_ENV,
  apiDomain: process.env.REACT_APP_API_DOMAIN,
  hiddenPaths: JSON.parse(process.env.REACT_APP_HIDDEN_PATHS),
  hiddenMenuPositions: JSON.parse(process.env.REACT_APP_HIDDEN_MENU_POSITIONS),
  serverResponseStatus: JSON.parse(process.env.REACT_APP_SERVER_RESPONSE_STATUS),
  hiddenMenuConsole: JSON.parse(hiddenMenuConsole),
  stripePublicKey: process.env.REACT_APP_STRIPE_PK_KEY,
  intercomePublicKey: process.env.REACT_APP_INTERCOME,
  showIntercomGlobally: process.env.REACT_APP_SHOW_INTERCOM_GLOBALLY,
  tryIterioFreeBtnEnabled: JSON.parse(process.env.REACT_APP_TRY_ITERIO_FREE_BTN_ENABLED),
  createJsUrl: process.env.REACT_APP_CREATEJS_URL,
  homeAnimationUrl: process.env.REACT_APP_HOME_ANIMATION_URL,
  hideModalDetails: process.env.REACT_APP_HIDE_MODAL_DETAILS,
};

export default config;



// WEBPACK FOOTER //
// ./src/config/config.js